/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Takenofflinedone2Inputs */

const en_takenofflinedone2 = /** @type {(inputs: Takenofflinedone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taken offline`)
};

const de_takenofflinedone2 = /** @type {(inputs: Takenofflinedone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline genommen`)
};

/**
* | output |
* | --- |
* | "Taken offline" |
*
* @param {Takenofflinedone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const takenofflinedone2 = /** @type {((inputs?: Takenofflinedone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Takenofflinedone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_takenofflinedone2(inputs)
	return de_takenofflinedone2(inputs)
});
export { takenofflinedone2 as "takenOfflineDone" }